import AssociatedCoursesList from './associated-courses-list';

export default {
  name       : 'SyncSummaryList',
  components : {
    AssociatedCoursesList
  },
  props: {
    currentTheme: {
      type    : String,
      default : 'theme--plataforma-white'
    },
    tableHeaders: {
      type    : Array,
      default : () => []
    },
    tableItems: {
      type     : Array,
      default  : () => [],
      required : true
    },
    typeCountText: {
      type     : String,
      required : true,
      default  : ''
    },
    emptyTitle: {
      type     : String,
      required : true,
      default  : ''
    },
    emptyText: {
      type     : String,
      required : true,
      default  : ''
    },
    isDetailModal: {
      type    : Boolean,
      default : false
    },
    type: {
      type      : String,
      default   : 'contentTypes',
      validator : function(value) {
        return ['associatedCourses', 'contentTypes'].includes(value);
      }
    }
  }
};
